"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutBoxIteratorOtherSubDocument = void 0;
var tslib_1 = require("tslib");
var document_layout_details_level_1 = require("../../layout/document-layout-details-level");
var layout_position_creator_1 = require("../layout-position-creator");
var layout_box_iterator_base_1 = require("./layout-box-iterator-base");
var LayoutBoxIteratorOtherSubDocument = (function (_super) {
    tslib_1.__extends(LayoutBoxIteratorOtherSubDocument, _super);
    function LayoutBoxIteratorOtherSubDocument(subDocument, layout, intervalStart, intervalEnd, pageIndex) {
        var _this = _super.call(this, subDocument, layout, intervalStart, intervalEnd) || this;
        _this.pageIndex = pageIndex;
        return _this;
    }
    LayoutBoxIteratorOtherSubDocument.prototype.isInitialized = function () {
        var page = this.layout.pages[this.pageIndex];
        if (!page || page.otherPageAreas[this.subDocument.id].getEndPosition() < this.intervalEnd)
            return false;
        return true;
    };
    LayoutBoxIteratorOtherSubDocument.prototype.getNewLayoutPosition = function (position, endRowConflictFlags, middleRowConflictFlags) {
        return new layout_position_creator_1.LayoutPositionOtherSubDocumentCreator(this.layout, this.subDocument, position, this.pageIndex, document_layout_details_level_1.DocumentLayoutDetailsLevel.Character)
            .create(endRowConflictFlags, middleRowConflictFlags);
    };
    return LayoutBoxIteratorOtherSubDocument;
}(layout_box_iterator_base_1.LayoutBoxIteratorBase));
exports.LayoutBoxIteratorOtherSubDocument = LayoutBoxIteratorOtherSubDocument;
